(function() {
  'use strict';
function randomSort(list) {
  // get all items to sort
  let listItems = list.querySelectorAll('div.award-item');
  if (listItems.length === 0) {
    return;
  }
  let listItemsParent = listItems[0].parentNode;
  // check if random sort values are set
  if (!('sort' in listItems[0].dataset)) {
    // set random sort value
    for (let i = 0; i < listItems.length; i++) {
      listItems[i].dataset.sort = '' + Math.floor(Math.random() * 64000);
    }
  }
  // sort items asc, toggle ratio classes for alternating height and append to parent
  let even = true;
  Array.from(listItems).sort(function(a, b){
    return (parseInt(a.dataset.sort, 10) - parseInt(b.dataset.sort, 10));
  }).forEach(function(el){
    even = !even;
    if (el.classList.contains('ratio-3-4') || el.classList.contains('ratio-1-1')) {
      el.classList.toggle('ratio-3-4', even);
      el.classList.toggle('ratio-1-1', !even);
    }
    listItemsParent.appendChild(el);
  });

  // move showmore button if exist to the end
  // let showmore = listItemsParent.querySelector('div:not(.award-item)');
  let showmore = listItemsParent.querySelector('[data-type="showmore-trigger"]');
  if (showmore) {
    listItemsParent.append(showmore);
    let visibleEls = list.querySelectorAll('div.award-item:not(.hidden):not([data-fixedpos])');
    let visible = visibleEls.length;
    // get current sorted items
    listItems = list.querySelectorAll('div.award-item:not([data-fixedpos])');
    for (let i = 0; i < listItems.length; i++) {
      if (i < visible) {
        listItems[i].classList.remove('hidden');
      } else {
        listItems[i].classList.add('hidden');
      }
    }
  }
  // get fixed pos items
  let fixedItems = list.querySelectorAll('div.award-item[data-fixedpos]');
  if (fixedItems.length > 0) {
    if (fixedItems.length > 1) {
      // sort fixed pos items by fixedpos
      fixedItems = fixedItems.sort((a, b) => {
        return (parseInt(a.dataset.fixedpos, 10) > parseInt(b.dataset.fixedpos, 10));
      });
    }
    // move fixed pos items to the end
    for (let i = 0; i < fixedItems.length; i++) {
      listItemsParent.append(fixedItems[i]);
    }
    // get current sorted items
    listItems = list.querySelectorAll('div.award-item');
    // move fixed pos items to it's place
    for (let i = 0; i < fixedItems.length; i++) {
      let fixedPos = fixedItems[i].dataset.fixedpos - 1;
      fixedItems[i].classList.remove('hidden');
      listItemsParent.insertBefore(fixedItems[i], listItems[fixedPos]);
    }
  }
}

// find lists for random sort
let lists = document.querySelectorAll("div[data-sorting='random']");
if (lists.length > 0) {
  for (let i = 0; i < lists.length; i++) {
    randomSort(lists[i]);
  }
}
})();
